import { Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  wrapperDivider: {
    borderColor: '#E9EFF2',
    borderBottomWidth: 1,
    paddingBottom: 16,
    paddingTop: 16,
  },
  titleText: {
    fontWeight: '700',
    fontSize: 24,
    lineHeight: 43.2,
    letterSpacing: 0,
  },
  subtitle: {
    fontWeight: '700',
    fontSize: 14,
    lineHeight: 25.2,
    letterSpacing: 0,
  },
  paragraph: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 25.2,
    letterSpacing: 0,
    color: '#6C777C',
  },
  containerSwitch: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
  },
  labelSwitch: {
    fontSize: 16,
    marginHorizontal: 15,
  },
  input: {
    width: '60%',
    height: 41,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    backgroundColor: '#E4EAEE',
    color: '#1A2737',
    opacity: 1,
  },
  disabledInput: {
    opacity: 0.3,
    color: '#6C777C',
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 5,
  },
  radioOuterCircle: {
    width: 16,
    height: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#007AFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioInnerCircle: {
    width: 9,
    height: 9,
    borderRadius: 6,
    backgroundColor: '#007AFF',
  },
  radioSelected: {
    borderColor: '#007AFF',
  },
  radioLabel: {
    fontWeight: '700',
    fontSize: 14,
    lineHeight: 25.2,
    letterSpacing: 0,
    marginLeft: 10,
  },
  floatingButton: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    backgroundColor: 'white',
    borderRadius: 20,
    elevation: 5, // Android shadow
    shadowColor: '#000', // iOS shadow
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  justifyContent: {
    justifyContent: 'space-around',
  },
  break: {
    marginTop: 10,
    marginBottom: 10,
  },
});

export default styles;
